import React from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'

// Routes
import Main from './routes/Main'

class App extends React.Component {
    render() {
        return (
            <Router>
                <Switch>
                    <Route component={Main} />
                </Switch>
            </Router>
        )
    }
}

export default App
